import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-video-line text-sm"></i>
            视频专区
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩视频推荐</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">精选热门爆料相关视频内容，深度解读每个热点事件。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}